import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import PayloadRawMaterialContext from "../../../context/materialcapture/PayloadRawMaterialContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import PayloadRawMaterialForm from "../../../components/materialscapture/PayloadRawMaterialForm";

const PayloadRawMaterialsCreatePage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { apiRes, setApiRes } = useContext(PayloadRawMaterialContext);

  const backURL = '/payload-raw-materials';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Payload Raw Materials']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Payload Raw Material Create'} backURL={backURL} />
        <PayloadRawMaterialForm />

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default PayloadRawMaterialsCreatePage;